<template>
  <div v-if="isRouterAlive" class="c-footer">
    <div>
      <div class="row footer-wide" style="padding:0 5vw;">
        <div class="col-sm footer1" style="margin-right:60px">
          <div class="link-title fontsiyuannormal">{{ $t("hosetitle") }}</div>
          <div class="link-title-content-group">
            <div
              class="link-title-content"
              v-for="(item, index) in JSON.parse($t('productlist1'))"
              v-bind:key="index"
                  @click="routerClick('/product?type=0&category='+index)"
            >
              {{ item}}
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="link-title fontsiyuannormal">{{ $t("metertitle") }}</div>
          <div class="link-title-content-group">
            <div
              class="link-title-content"
              v-for="(item, index) in JSON.parse($t('productlist2'))"
              v-bind:key="index"
                  @click="routerClick('/product?type=1&category='+index)"
            >
              {{ item}}
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="link-title fontsiyuannormal">{{ $t("abouttitle") }}</div>
          <div class="link-title-content-group">
            <div
              class="link-title-content"
                  @click="routerClick('/about?sort=0')"
            >
              {{  $t("aboutt1text")  }}
            </div>
            <div
              class="link-title-content"
                  @click="routerClick('/about?sort=1')"
            >
              {{  $t("aboutt2text")  }}
            </div>
            <div
              class="link-title-content"
                  @click="routerClick('/aboutend')"
            >
              {{  $t("aboutt3text")  }}
            </div>
            <div
              class="link-title-content"
            >
              {{  $t("aboutt4text")  }}
            </div>
            <div
              class="link-title-content"
            >
              {{  $t("aboutt5text")  }}
            </div>
            <div
              class="link-title-content"
            >
              {{  $t("aboutt6text")  }}
            </div>
            <div
              class="link-title-content"
            >
              {{  $t("aboutt7text")  }}
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="link-title fontsiyuannormal">{{  $t("movietitle")  }}</div>
          <div class="link-title-content-group">
            <div
              class="link-title-content"
                  @click="routerClick('/news2')"
            >
              {{  $t("moviet1text")  }}
            </div>
            <div
              class="link-title-content"
                  @click="routerClick('/news3')"
            >
              {{  $t("moviet2text")  }}
            </div>
            <div
              class="link-title-content"
                  @click="routerClick('/news4')"
            >
              {{  $t("moviet3text")  }}
            </div>
            <div
              class="link-title-content"
                  @click="routerClick('/news5')"
            >
              {{  $t("moviet4text")  }}
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="link-title fontsiyuannormal">{{  $t("socialtitle")  }}</div>
          <div class="link-title-content-group2 ">
            <!-- icon -->
            <div class="row">
              <div class="col-4">
                <b-img
                  src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-wechat.svg"
                  alt="宁波天鑫仪表有限公司"
                ></b-img>
              </div>
              <div class="col-4">
                <b-img
                  src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-sina.svg"
                  alt="宁波天鑫仪表有限公司"
                ></b-img>
              </div>
              <div class="col-4">
                <a
                  target="_blank"
                  href="http://wpa.qq.com/msgrd?v=3&uin=75965375&site=qq&menu=yes"
                >
                  <b-img
                    src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-contact.svg"
                    alt="宁波天鑫仪表有限公司"
                  ></b-img>
                </a>
              </div>
            </div>
            <!-- 微信 -->
            <div class="footer-wechat">
              <div>{{  $t("socialwechattext")  }}</div>
              <b-img
                style="margin-top:20px;"
                :src="$t('socialwechatimg')"
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
          </div>
        </div>
      </div>

      <!-- 手机版 -->
      <div class=" footer-thin">
        <b-container class="footer-thin-item">
          <div
            class="thin-item-header"
            :class="
              `${visible1 ? 'thin-item-header-none' : 'thin-item-header'}`
            "
            @click="collpose(1)"
          >
            <span class="thin-item-title">{{  $t("hosetitle")  }}</span>
            <span class="thin-item-button"
              ><img
                class=""
                :src="
                  visible1
                    ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-footer-exp.svg'
                    : 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-footer-close.svg'
                "
            /></span>
          </div>
          <b-collapse
            v-model="visible1"
            :class="`thin-item-body ${visible1 ? 'thin-item-body-line' : ''}`"
          >
            <div
              class="thin-item-click"
              v-for="(item, index) in JSON.parse($t('productlist1'))"
              v-bind:key="index"
                  @click="routerClick('/product?type=0&category='+index)"
            >
              {{ item}}
            </div>
          </b-collapse>
        </b-container>
        <b-container class="footer-thin-item">
          <div
            class="thin-item-header"
            :class="
              `${visible2 ? 'thin-item-header-none' : 'thin-item-header'}`
            "
            @click="collpose(2)"
          >
            <span class="thin-item-title">{{  $t("metertitle")  }}</span>
            <span class="thin-item-button"
              ><img
                class=""
                :src="
                  visible2
                    ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-footer-exp.svg'
                    : 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-footer-close.svg'
                "
            /></span>
          </div>
          <b-collapse
            v-model="visible2"
            :class="`thin-item-body ${visible2 ? 'thin-item-body-line' : ''}`"
          >
            <div
              class="thin-item-click"
              v-for="(item, index) in JSON.parse($t('productlist2'))"
              v-bind:key="index"
                  @click="routerClick('/product?type=1&category='+index)"
            >
              {{ item}}
            </div>
          </b-collapse>
        </b-container>
        <b-container class="footer-thin-item">
          <div
            class="thin-item-header"
            :class="
              `${visible3 ? 'thin-item-header-none' : 'thin-item-header'}`
            "
            @click="collpose(3)"
          >
            <span class="thin-item-title">{{  $t("abouttitle")  }}</span>
            <span class="thin-item-button"
              ><img
                class=""
                :src="
                  visible3
                    ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-footer-exp.svg'
                    : 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-footer-close.svg'
                "
            /></span>
          </div>
          <b-collapse
            v-model="visible3"
            :class="`thin-item-body ${visible3 ? 'thin-item-body-line' : ''}`"
          >
            <div
              class="thin-item-click"
                  @click="routerClick('/about?sort=0')"
            >
              {{ $t("aboutt1text") }}
            </div>
            <div
              class="thin-item-click"
                  @click="routerClick('/about?sort=1')"
            >
              {{ $t("aboutt2text") }}
            </div>
            <div
              class="thin-item-click"
                  @click="routerClick('/about?sort=2')"
            >
              {{ $t("aboutt3text") }}
            </div>
            <div
              class="thin-item-click"
                  @click="routerClick('/about?sort=3')"
            >
              {{ $t("aboutt4text") }}
            </div>
            <div
              class="thin-item-click"
                  @click="routerClick('/about?sort=4')"
            >
              {{ $t("aboutt5text") }}
            </div>
            <div
              class="thin-item-click"
                  @click="routerClick('/about?sort=5')"
            >
              {{ $t("aboutt6text") }}
            </div>
            <div
                  @click="routerClick('/about?sort=6')"
              class="thin-item-click"
            >
              {{ $t("aboutt7text") }}
            </div>
            <div
                  @click="routerClick('/about?sort=7')"
              class="thin-item-click"
            >
              {{ $t("aboutt8text") }}
            </div>
            <div
                  @click="routerClick('/about?sort=8')"
              class="thin-item-click"
            >
              {{ $t("aboutt9text") }}
            </div>
          </b-collapse>
        </b-container>
        <b-container class="footer-thin-item">
          <div
            class="thin-item-header"
            :class="
              `${visible4 ? 'thin-item-header-none' : 'thin-item-header'}`
            "
            @click="collpose(4)"
          >
            <span class="thin-item-title">{{ $t("movietitle") }}</span>
            <span class="thin-item-button"
              ><img
                class=""
                :src="
                  visible4
                    ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-footer-exp.svg'
                    : 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-footer-close.svg'
                "
            /></span>
          </div>
          <b-collapse
            v-model="visible4"
            :class="`thin-item-body ${visible4 ? 'thin-item-body-line' : ''}`"
          >
            <div
              class="thin-item-click"
                  @click="routerClick('/news2')"
            >
              {{ $t("moviet1text") }}
            </div>
            <div
              class="thin-item-click"
                  @click="routerClick('/news3')"
            >
              {{ $t("moviet2text") }}
            </div>
            <div
              class="thin-item-click"
                  @click="routerClick('/news4')"
            >
              {{ $t("moviet3text") }}
            </div>
            <div
              class="thin-item-click"
                  @click="routerClick('/news5')"
            >
              {{ $t("moviet4text") }}
            </div>
          </b-collapse>
        </b-container>
        <b-container>
        <div class="thin-contact-container">
          <b-row>
            <b-col cols="auto" class="mr-auto p-3">
              <div class="thin-contact-link-title">{{ $t("socialtitle") }}</div>
              <div class="row">
                <div class="col-4">
                  <a
                    target="_blank"
                    href="#"
                  >
                  <b-img
                    src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-wechat.svg"
                    alt="宁波天鑫仪表有限公司"
                  ></b-img>
                  </a>
                </div>
                <div class="col-4">
                  <a
                    target="_blank"
                    href="#"
                  >
                  <b-img
                    src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-sina.svg"
                    alt="宁波天鑫仪表有限公司"
                  ></b-img>
                  </a>
                </div>
                <div class="col-4">
                  <a
                    target="_blank"
                    href="http://wpa.qq.com/msgrd?v=3&uin=75965375&site=qq&menu=yes"
                  >
                    <b-img
                      src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/i-contact.svg"
                      alt="宁波天鑫仪表有限公司"
                    ></b-img>
                  </a>
                </div>
              </div>

              <div class="thin-contact-link-offical">
                {{ $t("socialwechattext") }}
              </div>
            </b-col>
            <b-col cols="auto" class="p-3">
              <b-img
                class="thin-contact-img"
                :src="$t('socialwechatimg')"
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </b-col>
          </b-row>
        </div>
        </b-container>
        <b-container>
          <div class="thin-contact-bottom"  @click="routContact">
            <!-- <span style="margin-right:20px;cursor: pointer;">{{$t('contacttianxin')}}</span><span class="bottom-beian" @click="routBeian">浙ICP备13037210号-1</span> -->
            <span style="margin-right:20px;cursor: pointer;">{{$t('contacttianxin')}}</span><span class="bottom-beian"><a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022005651号</a></span>
          </div>
        </b-container>
      </div>
    </div>
    <!-- 手机版 -->

    <div class="footer-bottom  footer-wide">
      <div class=" col-xs" >
        <!-- <span style="margin-right:20px;margin-left:5vw;cursor: pointer;"  @click="routContact">{{$t('contacttianxin')}}</span>©2004 - 2021 TIANXIN
        版权所有 <span class="bottom-beian" @click="routBeian">浙ICP备2022005651号</span> -->
         <span style="margin-right:20px;margin-left:5vw;cursor: pointer;"  @click="routContact">{{$t('contacttianxin')}}</span>©2004 - 2021 TIANXIN 
        版权所有 <span class="bottom-beian" ><a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022005651号</a></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    pipeseriesList() {
      return this.$store.state.product1List;
    },
    appearenaceList() {
      return this.$store.state.product2List;
    },
    aboutList() {
      return this.$store.state.about;
    },
    mediaList() {
      return this.$store.state.media;
    },
  },
  data() {
    return {
      isRouterAlive: true,

      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
    };
  },
  mounted(){
    this.getFooter2()
  },
  methods: {
routBeian(){
 window.open('https://beian.miit.gov.cn/', '_blank');
},
routContact(){
   this.$router.push({path:'/contact?p=c'});
},
    routerClick(url) {
      // this.$router.push({path:url});
      this.$router.push({path:url});

      // window.location.href=url
    },
     reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getFooter2() {
      const _this = this;
      this.$store.dispatch("getFooter2").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        _this.reload();
      });
    },
    collpose(i) {
      switch (i) {
        case 1:
          if (this.visible1) {
            this.visible1 = false;
            this.visible2 = false;
            this.visible3 = false;
            this.visible4 = false;
          } else {
            this.visible1 = true;
            this.visible2 = false;
            this.visible3 = false;
            this.visible4 = false;
          }
          break;
        case 2:
          if (this.visible2) {
            this.visible1 = false;
            this.visible2 = false;
            this.visible3 = false;
            this.visible4 = false;
          } else {
            this.visible1 = false;
            this.visible2 = true;
            this.visible3 = false;
            this.visible4 = false;
          }
          break;
        case 3:
          if (this.visible3) {
            this.visible1 = false;
            this.visible2 = false;
            this.visible3 = false;
            this.visible4 = false;
          } else {
            this.visible1 = false;
            this.visible2 = false;
            this.visible3 = true;
            this.visible4 = false;
          }
          break;
        case 4:
          if (this.visible4) {
            this.visible1 = false;
            this.visible2 = false;
            this.visible3 = false;
            this.visible4 = false;
          } else {
            this.visible1 = false;
            this.visible2 = false;
            this.visible3 = false;
            this.visible4 = true;
          }
          break;
      }
    },
  },
};
</script>
<style>
.c-footer {
  width: 100vw;
  background-color: #ededed;
  /* background-color: #ff0000; */
}
.footer1{
  margin-left:30px;
}
.fotter-header-link {
  width: 100vw;
  display: flex;
}
.link-title-content-group {
  margin-top: 20px;
  white-space: nowrap;
}
.link-title-content-group2 {
  margin-top: 20px;
}
.link-title-content {
  margin-bottom: 8px;
  font-size: 14px;
  color: #666666;
  font-weight: 100;
  cursor: pointer;
}
.link-title-content:hover {
  text-decoration: underline;
  color: #444444;
}
.link-title {
  font-size: 18px;
  margin-top: 70px;
  font-weight: bold;
}
.footer-bottom {
  margin-top: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  /* padding-left: 60px; */
  width: 100vw;
  background-color: #272727;
  color: #808080;
  font-size: 12px;
}
.bottom-contact {
  margin-top: 30px;
  margin-left: 60px;
  cursor: pointer;
}
.footer-wechat {
  font-size: 14px;
  font-weight: 100;
  margin-top: 20px;
}
.footer-media-icon {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.footer-media-icon:hover {
  width: 31px;
  height: 31px;
}
.footer-wechat img {
  margin-top: 10px;
}
.footer-thin {
  display: none;
}

@media only screen and (max-width: 1150px) {

.footer1{
  margin-left:0px;
  padding-left:0;
}
}
@media only screen and (max-width: 500px) {
  .footer-wide {
    display: none;
  }

  .footer-thin {
    display: block;
  }
  .thin-item-title {
    font-size: 15px;
    font-weight: bold;
  }
  .thin-item-click {
    font-size: 15px;
    color: #a4a4a4;
    font-weight: 200;
    margin: 10px 0;
  }
  .thin-item-button {
    position: absolute;
    right: 20px;
    font-size: 15px;
    width: 20px;
    height: 20px;
    color: #a4a4a4;
  }
  .thin-item-button img {
    width: 10px;
    height: 10px;
  }

  .thin-item-header {
    padding: 10px 0;
    border-bottom: 1px #a4a4a466 solid;
  }
  .thin-item-header-none {
    padding: 10px 0;
    border-bottom: 0px #a4a4a466 solid;
  }
  .thin-item-body-line {
    margin-bottom: 10px;
    border-bottom: 1px #a4a4a466 solid;
  }
  .thin-contact-container {
    margin-top: 50px;
    /* border-bottom: 1px #a4a4a466 solid; */
  }
  .thin-contact-container .col-4 {
    width: 10px;
  }
  .thin-contact-link-title {
    margin-bottom: 5px;
    font-size: 15px;
    font-weight: bold;
  }
  .thin-contact-link-offical {
    margin-top: 15px;
    font-size: 13px;
    font-weight: 200;
  }
  .thin-contact-bottom {
    font-size: 15px;
    text-align: center;
    color: #a4a4a4;
    border-top: 1px #a4a4a466 solid;
    padding: 30px 0;
    font-weight: 200;
  }
}
.footer-contact-img{
  cursor: pointer;
}
.bottom-beian{
  cursor: pointer;
}
</style>
